import React, { useState, useEffect } from 'react';
// Constants
import { CompanyName, MainTitle } from '../../utils/Constants';

function BigImageBookNow() {
  const [isIphone, setIsIphone] = useState(false);

  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      setIsIphone(/iPhone/.test(navigator.userAgent));
    }
  }, []);

  return (
    <section
      className={`grid relative w-full border-b-2 border-solid border-colour7 pb-10 min-h-screen lg:min-h-[150vh] bg-cover bg-top bg-no-repeat bg-mainPhone lg:bg-bigHome ${
        isIphone ? '' : 'bg-fixed'
      } `}
      aria-labelledby='big-image-heading'
    >
      <section className='absolute grid h-fit gap-y-2 max-h-[300px] md:left-8 top-24 z-20 text-center lg:text-left bg-black/50 lg:bg-transparent lg:text-colour2 max-w-xl'>
        <h1 className='md:text-2xl font-charm h-fit'>
          "Dream of a lifetime"...
        </h1>
        <p className='itlaic h-fit'>
          "Today was the best day of my submissive life! When YOU opened the
          door my dream of a lifetime became a fact, a beautiful Goddess who was
          a magnificent Mistress."
        </p>
        <p>- slave, May 2025</p>
      </section>

      <section className='absolute grid items-center left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 min-h-screen lg:min-h-[150vh] w-full text-center full_shadow_black_invert_big'>
        <div className='grid h-fit gap-12'>
          <h4 className='text-3xl md:text-5xl lg:text-9xl font-bold text-colour4 font-hello-paris-medium text_shadow'>
            {CompanyName}
          </h4>
          <h5 className='text-3xl md:text-5xl lg:text-4xl font-kugile font-bold text-colour4 text_shadow'>
            {MainTitle}
          </h5>
        </div>
      </section>
    </section>
  );
}

export default BigImageBookNow;
